'use client';

import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_LOCALE, type Locale } from './config';
import { createT, type Namespace } from './messages';

/**
 * 서버가 정한 요청 언어를 클라이언트 컴포넌트에 넘긴다.
 * usePathname() 은 rewrite 된 경로와 주소창 경로 중 어느 쪽을 줄지 믿기 어려워 경로로 언어를 짐작하지 않는다.
 */
const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

export function LocaleProvider({
  locale,
  children
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

export function useT(ns: Namespace) {
  const locale = useLocale();
  return useMemo(() => createT(locale, ns), [locale, ns]);
}
